export const SN_PRODUCT_MAPPING_STATUS = {
  PENDING_ASSIGNMENT: 'PENDING_ASSIGNMENT',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const SN_PRODUCT_MAPPING_STATUS_LABELS = {
  PENDING_ASSIGNMENT: '待指定',
  ACTIVE: '啟用',
  INACTIVE: '停用',
};

export const SN_PRODUCT_MAPPING_STATUS_FILTER_OPTIONS = Object.entries(
  SN_PRODUCT_MAPPING_STATUS_LABELS,
).map(([value, label]) => ({ value, label }));

export function formatSnProductMappingStatusLabel(status) {
  if (status == null || status === '') {
    return '-';
  }
  return SN_PRODUCT_MAPPING_STATUS_LABELS[status] ?? status;
}

export function isPendingSnProductMapping(status) {
  return status === SN_PRODUCT_MAPPING_STATUS.PENDING_ASSIGNMENT;
}

export function canEditSnProductMappingIdentity(status) {
  return !status || isPendingSnProductMapping(status);
}

export function canActivateSnProductMapping(detail) {
  if (!detail) {
    return false;
  }
  if (detail.status === SN_PRODUCT_MAPPING_STATUS.INACTIVE) {
    return true;
  }
  return isPendingSnProductMapping(detail.status) && Boolean(detail.customerId);
}

export function canDeactivateSnProductMapping(status) {
  return status === SN_PRODUCT_MAPPING_STATUS.ACTIVE;
}

export function canDeleteSnProductMapping(status) {
  return isPendingSnProductMapping(status);
}
